import { BdEquals } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdBooleanCondition
} from '@bindoc-projects/condition-domain-lib';
import type { FilterDetailedText } from '../filter-detailed-text';

export const AT_TAGESFALL_CONDITION_ID = 'tagesfallAT';
export const AtFilterConditionTagesfallPluginType: FilterConditionPluginSpecification<
  boolean,
  AtFilterConditionTagesfallDto,
  BdTagesfallATCondition
> = {
  type: 'tagesfallAT',
  category: 'case',
  displayName: { de: 'Tagesfall' },
  sortingIndex: 13,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionTagesfallDto,
  ): FilterConditionPluginImpl<boolean> {
    return new AtFilterConditionTagesfallPlugin(obj.tagesfall);
  },
  fromCondition(
    jsonObj: BdTagesfallATCondition,
  ): FilterConditionPluginImpl<boolean> {
    return new AtFilterConditionTagesfallPlugin(jsonObj.flag);
  },
  newInstance(): FilterConditionPluginImpl<boolean> {
    return new AtFilterConditionTagesfallPlugin(true);
  },
};

export class AtFilterConditionTagesfallPlugin extends FilterConditionPluginImpl<
  boolean,
  AtFilterConditionTagesfallDto
> {
  static override Specification: FilterConditionPluginSpecification<
    boolean,
    AtFilterConditionTagesfallDto,
    BdTagesfallATCondition
  > = AtFilterConditionTagesfallPluginType;

  constructor(private bool: boolean) {
    super(AtFilterConditionTagesfallPluginType.type);
  }

  clone(): AtFilterConditionTagesfallPlugin {
    return new AtFilterConditionTagesfallPlugin(this.bool);
  }

  override equals(other: AtFilterConditionTagesfallPlugin): boolean {
    return super.equals(other) && BdEquals.equals(this.bool, other.bool);
  }

  override valid(): boolean {
    return this.bool !== null && this.bool !== undefined;
  }

  override validationToText(): string {
    return this.valid() ? '' : 'Kriterium auswählen';
  }

  toCondition(): BdCondition | null {
    return new BdTagesfallATCondition(this.bool);
  }

  toJSON(): AtFilterConditionTagesfallDto | null {
    return {
      type: this.type,
      tagesfall: this.bool,
    };
  }

  toText(): string | null {
    return this.bool ? 'Tagesfall' : 'Kein Tagesfall';
  }

  override toDetailedText(): FilterDetailedText | null {
    const title = this.toText();
    if (!title) return null;
    return { title, items: [] };
  }

  toValue(): boolean {
    return this.bool;
  }
}

export class BdTagesfallATCondition extends BdBooleanCondition {
  constructor(public flag: boolean) {
    super(AT_TAGESFALL_CONDITION_ID, flag);
  }
}

interface AtFilterConditionTagesfallDto {
  type: string;
  tagesfall: boolean;
}
